import { put, call, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/users";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";

function* importersListSaga({ payload }) {
  try {
    const response = yield call(apis.importersList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.importersListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.importersListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* exportersListSaga({ payload }) {
  try {
    const response = yield call(apis.exportersList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.exportersListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.exportersListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getImporterDetailsSaga({ payload }) {
  try {
    const response = yield call(apis.getImporterDetails, payload);
    yield put(actions.getImporterDetailsResponse(response.data.Data));
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getExporterCompanyDetailsSaga({ payload }) {
  try {
    const response = yield call(
      apis.getExporterCompanyDetails,
      payload
    );
    yield put(
      actions.getExporterCompanyDetailsResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getExporterContactInfoSaga({ payload }) {
  try {
    const response = yield call(apis.getExporterContactInfo, payload);
    yield put(
      actions.getExporterContactInfoResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}
function* getCompanyContactInfoSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyContactInfo, payload);
    yield put(
      actions.getCompanyContactInfoResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getExporterVerificationInfoSaga({ payload }) {
  try {
    const response = yield call(
      apis.getExporterVerificationInfo,
      payload
    );
    yield put(
      actions.getExporterVerificationInfoResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getExporterTransactionsListSaga({ payload }) {
  try {
    const response = yield call(
      apis.getExporterTransactionsList,
      payload
    );
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.getExporterTransactionsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* getExporterAccountInfoSaga({ payload }) {
  try {
    const response = yield call(apis.getExporterAccountInfo, payload);
    yield put(
      actions.getExporterAccountInfoResponse(response.data.Data)
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* blockImporterSaga({ payload }) {
  try {
    yield call(apis.blockImporter, payload);
    showSuccessMsg("blockImporter");
    yield put(
      actions.getImporterDetailsRequest({ id: payload.data.id })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* unblockImporterSaga({ payload }) {
  try {
    yield call(apis.unblockImporter, payload);
    showSuccessMsg("unblockImporter");
    yield put(
      actions.getImporterDetailsRequest({ id: payload.data.id })
    );
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* combinedListSaga({ payload }) {
  try {
    const response = yield call(apis.combinedList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.combinedListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.combinedListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* UsersSagas() {
  yield takeLatest(types.IMPORTERS_LIST_REQUEST, importersListSaga);
  yield takeLatest(types.EXPORTERS_LIST_REQUEST, exportersListSaga);
  yield takeLatest(
    types.GET_IMPORTER_DETAILS_REQUEST,
    getImporterDetailsSaga
  );
  yield takeLatest(
    types.GET_EXPORTER_COMPANY_DETAILS_REQUEST,
    getExporterCompanyDetailsSaga
  );
  yield takeLatest(
    types.GET_EXPORTER_CONTACT_INFO_REQUEST,
    getExporterContactInfoSaga
  );
  yield takeLatest(
    types.GET_EXPORTER_VERIFICATION_INFO_REQUEST,
    getExporterVerificationInfoSaga
  );
  yield takeLatest(
    types.GET_EXPORTER_TRANSACTIONS_LIST_REQUEST,
    getExporterTransactionsListSaga
  );
  yield takeLatest(
    types.GET_COMPANY_CONTACT_INFO_REQUEST,
    getCompanyContactInfoSaga
  );
  yield takeLatest(
    types.GET_EXPORTER_ACCOUNT_INFO_REQUEST,
    getExporterAccountInfoSaga
  );
  yield takeLatest(types.BLOCK_IMPORTER_REQUEST, blockImporterSaga);
  yield takeLatest(
    types.UNBLOCK_IMPORTER_REQUEST,
    unblockImporterSaga
  );
  yield takeLatest(types.COMBINED_LIST_REQUEST, combinedListSaga);
}
